module.exports = "pegasus/assets/square-facebook.png";